import { LwApiPM } from "@techniaorg/liteweb-api";
import { waitForIFrameAndModel } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrameAndModel(myframe)
  .then((api) => {
    LwAPI = api;
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

function ex_setbbvis(b: boolean) {
  LwAPI?.setBoundingBoxVisibility(b);
}
// Bind functions to buttons
document.getElementById("set1")?.addEventListener("click", async () => {
  await apiReady;
  ex_setbbvis(false);
});
document.getElementById("set2")?.addEventListener("click", async () => {
  await apiReady;
  ex_setbbvis(true);
});
